import { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

const Skeleton = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('animate-pulse rounded-md bg-muted', className)}
    {...props}
  />
);

export const TableSkeleton = ({
  rows = 5,
  columns = 4,
}: {
  rows?: number;
  columns?: number;
}) => (
  <div className="w-full space-y-3">
    <div className="flex gap-3">
      {Array.from({ length: columns }, (_, i) => i).map((col) => (
        <Skeleton key={`col-${col}`} className="h-10 flex-1" />
      ))}
    </div>
    {Array.from({ length: rows }, (_, i) => i).map((row) => (
      <div key={`row-${row}`} className="flex gap-3">
        {Array.from({ length: columns }, (_, i) => i).map((col) => (
          <Skeleton key={`cell-${col}`} className="h-12 flex-1" />
        ))}
      </div>
    ))}
  </div>
);
